import './titleBanner.scss';

import { Button } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

interface ITitleBannerProps {
    bgImage?: string;
    imageData?: any;
    title: string;
    className?: string;
    content?: any;
    button?: { text: string; image: any };
}

export default function TitleBanner(props: ITitleBannerProps) {
    return (
        <div className={`title-banner ${props.className}`}>
            {props.bgImage && <img src={props.bgImage} alt='' />}
            {props.imageData && <GatsbyImage image={props.imageData} alt='' />}
            <div className='title-banner-title'>
                <h1>{props.title}</h1>
                <span className='banner-title-line' />
                {props?.content && (
                    <div
                        className='title-banner-content'
                        dangerouslySetInnerHTML={{
                            __html: props.content,
                        }}
                    />
                )}

                {props?.button && (
                    <Button
                        link='/warranty-registration/'
                        label={props.button?.text}
                        iconRight={props.button?.image}
                    />
                )}
            </div>
        </div>
    );
}
